import { ButtonGroup, ButtonIcon, Card, Icon, CardV2, Tooltip } from 'pepsico-ds';
import React, { useEffect, useState } from 'react'
import { appNames } from '../../constants/appNames';
import CompassModal from '../Modal/CompassModal';
import { formatNumberWithCommas, returnHyphenIfNull, splitValueWithUnit } from '../../utils/utils';
import InfoIcon from '../Icons/InfoIcon';
import { showChartDisplayError, useButtonItemsArray, vlaidateLandingPageFilters } from './CardUtils';
import { getUserClaims } from '../../utils/auth/unified-auth';
import { useSelector } from 'react-redux'
import { Divider } from 'antd';
import PowerSteeringModal from '../Modal/PowerSteeringModal';
import BuyerConButtonIcon from "../Button/BuyerConButtonIcon"
import CustomButtons from './CustomButtons';
import EDF_checked from "../../../src/assets/EDF_checked.svg";
import { staticNotes } from '../../constants/staticNotes';


function PowerSteeringCard({ data, capability, selectedYear, userDataLandingPage, landingPageFilters, disabled=false }) {
    const [openModal, setOpenModal] = useState(false)
    // const [userData, setUserData] = useState({})
    const userData = useSelector((state) => state?.localData?.data?.oktaUserData);
    const [buttonGroupItems, setButtonGroupItems] = useState([])
    const [appName, setAppName] = useState('Power Steering');
    


    // useEffect(() => {
    //     async function getUserInfo() {
    //         const userInfo = await getOktaUserClaims(getOktaAuth())
    //         setUserData(userInfo)
    //     }
    //     getUserInfo()

    // }, [])

    // const currentYear = new Date().getFullYear()
    // console.log("currentYear", currentYear)
    // console.log("landingPageFilters", landingPageFilters)
    // const isYTDDisplay = (currentYear == landingPageFilters.year?.[0]?.["displayText"] ? true : false)
    // console.log("isYTDDisplay", isYTDDisplay)

    const dataAvailableNote = data?.latestFileName
    const YTDDisplayflag = dataAvailableNote ? dataAvailableNote === ("P13") : false;


    useEffect(() => {
        if (data && Object.keys(data).length > 0) {
            const tempbuttonGroupItems = data && data?.apps && data?.apps.length > 0 ? data?.apps?.filter(item => item.isActive)?.map((app) => ({
                label: app.app,
                chartDisplay: app.chartDisplay,
                onClick: () => window.open(app.url, "_blank"), // Opens the app in a new tab
            })) : [];
            // console.log("power-tempbuttonGroupItems", tempbuttonGroupItems)
            setButtonGroupItems(tempbuttonGroupItems)
        }
    }, [data])

    const buttonGroupDropdownItems = useButtonItemsArray(buttonGroupItems, setAppName, landingPageFilters, setOpenModal, openModal, capability);

    const enableChartDisplayButton = [appNames.spend, appNames.contract, appNames.sustainability, appNames.coman, appNames.compass, appNames.archlet, appNames.powersteering].includes(capability) &&
        buttonGroupDropdownItems.length < 3 && buttonGroupDropdownItems?.[1]?.chartDisplay;
    const appData = [
            {
              app: "Power Steering",
              url: "https://psxl.psteering.com/PepsiCoNextGen/Home.epage",
              isActive: true,
              chartDisplay: true,
              logo: 'Forestreet',
            },
            {
              app: "Cockpit - Global",
              url: "https://cockpit.mypepsico.com/views/ProductivityDirectMaterials/DirectsDetails",
              isActive: true,
              chartDisplay: true,
              logo: 'spendHQ',
            },
            {
              app: "Cockpit - AMESA",
              url: "https://cockpit.mypepsico.com/#/views/GlobalProductivity_16898878449100/ProductivityOverview?:iid=1",
              isActive: true,
              chartDisplay: true,
              logo: 'Forestreet',
            },
            {
              app: "Cockpit - APAC",
              url: "https://cockpit.mypepsico.com/#/views/PECNewMetrics/CommodityProductivity?:iid=1",
              isActive: true,
              chartDisplay: true,
              logo: 'spendHQ',
            }
          ];
    return (
        <>
            <div className="kpi-card-header">
                                <div className="kpi-card-title">
                                    {data?.title}
                                    {
                                        data?.edfintegrated &&
                                        <Tooltip direction="bottom" text={staticNotes.EDF_NOTE} style={{ marginTop: 13 }}>
                                            <img src={EDF_checked} alt='image' style={{ width: '18px', height: '22px', marginLeft: "8px", overflow:"visible" }} />
                                        </Tooltip>
                                    }
                                </div>
                                <div>
                                    {
                                        buttonGroupDropdownItems.length === 2 ?
                                            <div className="kpi-card-header-icons">
                                                {BuyerConButtonIcon(enableChartDisplayButton, landingPageFilters, setOpenModal, openModal, capability, disabled)}
                                            </div>
                                            :
                                            <ButtonGroup
                                                itemCount={1}
                                                groupDisabled = {disabled}
                                                items={buttonGroupDropdownItems}
                                                showMore
                                                size="medium"
                                                className="kpiCardButtomGroup"
                                            />
                                    }
                                </div>
                            </div>
                            {
                                <div className="kpi-card-middle-content">
                                    <div className="kpi-card-middle-content-left" style={{ width: '65%' }}>
                                        {
                                            data?.currentYearActual ?
                                                <div className="kpi-card-alphanumeric-value">
                                                    {

                                                        <>
                                                            <div className='kpi-card-numeric-value' style={{ fontSize: 50 }}>
                                                                {splitValueWithUnit(data?.currentYearActual)?.['numericValue']}
                                                            </div>
                                                            <div className="kpi-card-alpha-value" style={{ display: "flex", alignItems: 'flex-end' }}>
                                                                {splitValueWithUnit(data?.currentYearActual)?.['unit']}
                                                            </div>
                                                        </>
                                                    }

                                                    <InfoIcon style={{ 'line-height': '4rem' }} text={`Actuals ${!YTDDisplayflag ? "YTD" : ""}`} direction='right'/>
                                                </div>
                                                :
                                                <div className="kpi-card-alphanumeric-value">
                                                    <div className='kpi-card-numeric-value'>N/A<sup><InfoIcon text="Data is not available for the given filter combination. Please adjust your selection." direction='right'/></sup></div>
                                                </div>
                                        }
                                        <div>
                                            {/* <div className="kpi-card-numeric-value-tagline">Productivity Plan {!YTDDisplayflag ? "YTD" : ""}: <span style={{ fontWeight: 700 }}>{data.currentYearAopSaving || 0}</span></div> */}
                                            <div className="kpi-card-numeric-value-tagline">{data?.description}</div>
                                            <div className="kpi-card-numeric-value-tagline">{data?.subDescription}<span style={{ fontWeight: 700 }}>{data.currentYearAopSaving || 0}</span></div>
                                        </div>
                                        <div className="kpi-card-last-update" style={{ width: '100%', textAlign: 'left' }}>{data?.lastUpdate && data?.refreshFrequency? `${data.lastUpdate} | ${data.refreshFrequency}`: data?.lastUpdate || data?.refreshFrequency || ''}</div>
                                    </div>
                                    <div className="kpi-card-middle-content-right">
                                        <div className="kpi-card-last-year-value">
                                            <span className="last-year">LY</span>
                                            {
                                                data?.lastYearActual ?
                                                    <>
                                                        <span className="last-year-value">{splitValueWithUnit(data?.lastYearActual)?.['numericValue']}{splitValueWithUnit(data?.lastYearActual)?.['unit']}</span>
                                                    </> : <span className="last-year-value">N/A</span>
                                            }
                                        </div>
                                        {
                                            data?.percentage ?
                                                <>
                                                    <div className="kpi-card-percentage-value"
                                                    style={{ backgroundColor: parseFloat(data?.percentage) == 0 ? "#66c0e3" : (parseFloat(data?.percentage) > 0 ? "#006A42" : "#AA001A"), width: "74px" }}>{data?.percentage}%
                                                        <Icon
                                                            alt="alt value"
                                                            icon={parseFloat(data?.percentage) == 0 ? "" : (parseFloat(data?.percentage) > 0 ? "arrow_upward" : "arrow_downward")}
                                                            size="small"
                                                            style={{ color: '#fff' }}
                                                        />
                                                    </div>
                                                </> : ""
                                        }
                                    </div>
                                </div>
                            }
                            
                            <div className="kpi-card-footer">
                                <CustomButtons appList={data?.apps} disabled={disabled}/>
                            </div>
            {
                openModal && capability == appNames.powersteering && <PowerSteeringModal openModal={openModal} setOpenModal={setOpenModal} userData={userData} selectedYear={selectedYear} capability={capability} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageFilters} />
            }
        </>
    )
}

export default PowerSteeringCard